export default {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'ENTITY-LOCATION': {
    ADD_LOCATION_TITLE: 'Add new branch',
    TITLE: 'Manage branches',
    TABLE: {
      TITLE: 'Branches list',
      FILTERS: {
        SEARCH: 'Search',
        SEARCH_PLACEHOLDER: 'Search by name, city or address',
      },
      HEADER: {
        NAME: 'Name',
        ADDRESS: 'Address',
        CREATED_AT: 'Date',
        CREATED_AT_TOOLTIP: 'Date when the branch was created',
        CREATED_BY: 'Created by',
        CITY: 'City',
        STATE: 'State / Province',
        COUNTRY: 'Country',
        ACTIONS: 'Actions',
      },
      ACTIONS: {
        DELETE: 'Delete branch',
        EDIT: 'Edit branch',
      },
      NO_DATA: 'No branches added yet.',
    },
    DELETE: {
      CONFIRM_DELETE: {
        HEADER: 'Delete this branch?',
        MESSAGE: 'Are you sure you want to delete this branch?<br>⚠️ This action is <strong>permanent and irreversible.</strong><br>All offers from this branch and their associated data will be deleted.',
        CHECKBOX_LABEL: 'I confirm I understand this cannot be undone.',
        ACCEPT: 'Delete',
        REJECT: 'Cancel',
      },
      CONFIRM_DELETE_FINAL: {
        HEADER: 'Are you completely sure?',
        MESSAGE: '🔴 Once deleted, <strong>there is no going back.</strong><br>You will permanently lose all offers and data from this branch.',
        ACCEPT: 'Yes, permanently delete',
        REJECT: 'Cancel',
      },
      SUCCESS_DELETE: {
        HEADER: 'Location deleted',
        MESSAGE: 'Location deleted successfully.',
      },
    },
    FORM: {
      TITLE_CREATE: 'Add branch',
      TITLE_EDIT: 'Edit branch',
      FIELDS: {
        NAME: {
          LABEL: 'Location name',
          PLACEHOLDER: 'Enter branch name',
        },
        ADDRESS: {
          LABEL: 'Address',
          PLACEHOLDER: 'Enter address',
          HINT: 'Type an address and select a match from the list.',
        },
        CITY: { LABEL: 'City', PLACEHOLDER: 'Enter the city...' },
        STATE: {
          LABEL: 'State / Province',
          NOT_DETECTED_ERROR: 'Select a more precise address so this field can be auto-filled.',
        },
        COUNTRY: { LABEL: 'Country' },
        AUTOCOMPLETE_PLACEHOLDER: 'Auto-filled',
        CHANGE_IN_ADDRESS_TOOLTIP: 'This field updates automatically when you change the «Address».',
      },
      BUTTONS: {
        SAVE: 'Save',
        CANCEL: 'Cancel',
        DELETE: 'Delete',
      },
      MESSAGES: {
        CREATED: 'Location added successfully.',
        UPDATED: 'Location updated successfully.',
      },
    },
    ERRORS: {
      NOT_FOUND: 'Location not found.',
      NOT_AUTHORIZED: 'You don\'t have permission to do this.',
      UNKNOWN_ERROR: 'Something went wrong. Please try again.',
    },
  },
} as const;
